import { render } from "./TableBox.vue?vue&type=template&id=b0e607de&scoped=true"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"

import "./TableBox.vue?vue&type=style&index=0&id=b0e607de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e607de"]])

export default __exports__